<template lang="pug">
.marketing-leader-audit(v-loading="loading")
  title-bar
    span {{ $t('项目信息') }}
  div(style="margin-left: 20px")
    campaign-info(:data="campaignInfo")
  title-bar
    span {{ $t('项目审核') }}
  div(style="margin-left:20px")
    marketing-audit(:auditData="auditData" ref="audit")
  el-row(
    v-if="!isView"
    style="margin-left: 20px"
  )
    el-col(
      :span="20"
      :offset="4"
    )
      footer-button(
        @confirm="submit"
        @cancel="cancel"
      )
  audit-versions(
    :id="campaignId"
    :auditType="1"
    :businessType="businessType"
  )
</template>
<script>
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import MarketingAudit from '@/components/MarketingAudit'
import CampaignInfo from './CampaignInfo'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import AuditVersions from '@/components/AuditVersions'

export default {
  components: {
    TitleBar,
    FooterButton,
    MarketingAudit,
    CampaignInfo,
    AuditVersions
  },
  data () {
    return {
      loading: false,
      campaignId: this.$store.state.campaign.id,
      campaignInfo: {
        campaignName: '',
        brand: [],
        bypass: '',
        hasIT: '',
        hasIO: '',
        IO: [],
        budget: '',
        startDate: '',
        endDate: '',
        intro: '',
        remark: ''
      },
      auditData: {
        result: 1,
        remark: ''
      }
    }
  },
  mounted () {
    this.getCampaignInfo()
    if (this.isView) {
      this.getApproveResult()
    }
  },
  computed: {
    businessType () {
      return this.$store.state.campaign.businessType
    }
  },
  methods: {
    getCampaignInfo () {
      axios
        .get('/management/campaign/getCampaign', {
          params: {
            campaign_id: this.campaignId,
            is_final_scope: 0
          }
        })
        .then((res) => {
          this.campaignInfo = res
        })
    },
    async submit () {
      const validateResult = await this.$refs.audit.$validator.validate()
      if (!validateResult) return
      this.loading = true
      const params = {
        campaign_id: this.$store.state.campaign.id,
        approve_result: this.auditData.result,
        remark: this.auditData.remark,
        servlet_path: this.$route.path,
        task_name: this.$store.state.campaign.taskName,
        task_id: this.$store.state.campaign.taskId
      }
      axios.post('/management/campaign/approveCampaign', format4backend(params))
        .then(() => {
          this.loading = false
          this.$router.push('/campaign/process')
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel () {
      this.$router.push('/campaign/process')
    },
    getApproveResult () {
      axios
        .get('/management/subfinal/getApproveResult', {
          params: {
            id: this.campaignId,
            audit_type: 1,
            business_type: this.businessType
          }
        })
        .then(res => {
          this.auditData.result = res.status
          this.auditData.remark = res.comment
        })
    }
  }
}
</script>
